class Notices {
    constructor(hostname, path = '/api') {
        this._api = hostname + path
        this._hostname = hostname
        this._path = path
    }

    get query (){
        return this._api + '/notice/getnoticelist'
    }
    get handle (){
        return this._api + '/notice/operationnotice'
    }
    get inbox () {
        return this._api + '/notice/getselfnoticelist'
    }
    get read () {
        return this._api + '/notice/updateflag'
    }
    get status () {
        return this._api + '/notice/getflagnumber'
    }
}
export default Notices
